import React from 'react';
import { Alert, Box, CircularProgress, Stack, Typography } from '@mui/material';
import CodeSnippetRenderer from '../../../components/CodeSnippetRenderer';
import appConfig from '../../../config/appConfig';

const PreviewPanel = ({ result, isLoading, missingFields, showTrace = true }) => {
  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 1 }}>
        Preview transform
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        Run the mapping against your sample JSON. Save the draft first so the server compiles the latest config.
      </Typography>

      {missingFields?.length > 0 && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Missing required mappings: {missingFields.join(', ')}
        </Alert>
      )}

      {!result && (
        <Alert severity="info">
          Click &quot;Run preview&quot; to see the transformed {appConfig.brandName} payload.
        </Alert>
      )}
      {result && (
        <Stack spacing={2}>
          <Alert severity={result.success ? 'success' : 'error'}>
            {result.success ? 'Transform succeeded' : 'Transform completed with errors'}
          </Alert>

          {result.errors?.length > 0 && (
            <Alert severity="error">
              <Typography variant="subtitle2">Errors</Typography>
              <pre style={{ margin: 0, fontSize: '0.75rem', whiteSpace: 'pre-wrap' }}>
                {JSON.stringify(result.errors, null, 2)}
              </pre>
            </Alert>
          )}

          {result.warnings?.length > 0 && (
            <Alert severity="warning">
              <Typography variant="subtitle2">Warnings</Typography>
              <pre style={{ margin: 0, fontSize: '0.75rem', whiteSpace: 'pre-wrap' }}>
                {JSON.stringify(result.warnings, null, 2)}
              </pre>
            </Alert>
          )}

          <CodeSnippetRenderer title="Transformed payload" payload={result.transformedPayload} />

          {showTrace && result.trace?.length > 0 && <CodeSnippetRenderer title="Trace" payload={result.trace} />}
        </Stack>
      )}
    </Box>
  );
};

export default PreviewPanel;
